import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HttpModule } from '@angular/http';

import { HomeService } from './home.service';
import { HomeRoutingModule } from './home.routes';
import { SharedModule } from '../shared-components/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StandardUser } from '../core/standardUser.guard';
import { PremiumUser } from '../core/premiumUser.guard';


// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    HttpModule, HomeRoutingModule, SharedModule, TranslateModule.forRoot()
  ],
  exports: [HomeComponent],
  declarations: [HomeComponent],
  providers: [HomeService, StandardUser, PremiumUser]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts